import { NoteIcon } from "@phosphor-icons/react"

import { PagePlaceholder } from "@/components/page-placeholder"

export function NotesPage() {
  return (
    <PagePlaceholder
      title="Notes"
      description="Your notes will show up here."
      icon={NoteIcon}
    />
  )
}
